<template>
  <div>
    <Head title="會員中心 - 推薦成員查看" />
    <member-template title="會員中心">
      <template #header>推薦成員查看</template>

      <div v-if="parent" class="info-item">
        <div>推薦人</div>
        <div class="info-subitem">
          <div class="column">
            <label>姓名</label>
            {{ parent.name }}
          </div>

          <div class="column">
            <label>加入時間</label>
            {{ formatDate(parent.created_at) }}
          </div>

          <div class="column">
            <label>會員等級</label>
            {{ memberString(parent.level) }}
          </div>
        </div>
      </div>

      <div class="info-item">
        <div>已推薦成員 ({{ children.length }})</div>
        <div class="info-subitem">
          <div class="column">
            <label>姓名</label>
            <span :key="child.id + '_name'" v-for="child in children">
              {{ child.name }}
            </span>
          </div>

          <div class="column">
            <label>加入時間</label>
            <span :key="child.id + '_created'" v-for="child in children">
              {{ formatDate(child.created_at) }}
            </span>
          </div>

          <div class="column">
            <label>會員等級</label>
            <span :key="child.id + '_level'" v-for="child in children">
              {{ memberString(child.level) }}
            </span>
          </div>
        </div>
      </div>
    </member-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import MemberTemplate from "./Shared/MemberTemplate";

export default {
  components: {
    MemberTemplate,
  },
  layout: Layout,
  props: { parent: Object, children: Array },
  data() {
    return {
      //
    };
  },
  methods: {
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0")
      );
    },
    memberString(level) {
      switch (level) {
        case 0:
          return "新晉會員";
        case 1:
          return "一般會員";
        case 2:
          return "推廣會員";
        default:
          return "會員";
      }
    },
  },
};
</script>

<style lang="postcss">
.info-item {
  @apply mb-5 p-2 border border-fh-gray-border;
}

.info-subitem {
  @apply mt-2 py-2 flex justify-start flex-wrap gap-8;
}

.info-subitem .column {
  @apply flex flex-col basis-1/4;
}

.info-subitem .column label {
  @apply text-xs;
}
</style>